module.exports = __webpack_public_path__ + "static/media/maxim5.228408b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/maxim5.png
// module id = 685
// module chunks = 0